// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import LivreProfileLayout from './LivreProfileLayout';

import LivreService from '../../services/LivreService';

const DeleteLivre = () => {
	const [livre, setlivre] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([LivreService.getLivre(id)]).then(([livreData]) => {
			setlivre(livreData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the LivreService to delete the livre
			await LivreService.deletelivre(id);

			// Redirect the user to the list of livres
			navigate('/services/bibliotheque/catalogue');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations du livre ",
				error
			);
		}
	};

	return (
		<LivreProfileLayout>
			{livre && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{livre.titre || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement ce livre.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez ce livre, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le livre
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</LivreProfileLayout>
	);
};

export default DeleteLivre;
